module.exports = __webpack_public_path__ + "img/pro_three_4.712dbb50.jpg";